import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AssignRecruiterFormComponent } from '../assign-recruiter-form/assign-recruiter-form.component';
import { JobPositionService } from '@app/services/jobPosition.service';
import { TechnologySerializer } from '@app/model/serializer/technology-serializer';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.css'],
})
export class JobComponent implements OnInit {
  subscription: any;
  constructor(public _apiService: JobPositionService
    ,private _router :Router
    ) { 
      this._router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };
      this.subscription = this._router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // Trick the Router into believing it's last link wasn't previously loaded
          //this._router.navigated = false;
        }
      });
    }
  columns: any[];
  openModal:any;
  component:string;
  fields :any;
  display: boolean =false;
  componenetToOpen:String;
  displayAssignRecruiter: boolean;
  reload=[];
  reloadFields :any=false;
  ngOnInit() {
    localStorage.setItem("clearFilter","true");
    this.columns = [
      { field: 'createdOn', header: 'Created Date', type: 'date', sort:{required: true,sortBy:'createdOn'}  },
      { field: 'jobDescription', subfield: 'name', header: 'JD Name',params :{type:'JDName'}, sort:{required: true,sortBy:'jobDescription.name'} },
      { field: 'technology', subfield: 'name', header: 'Technology', sort:{required: true,sortBy:'technology.name'} },
      { field: 'jobCategory', subfield: 'name', header: 'Role' , sort:{required: true,sortBy:'jobCategory.name'}},
      { field: 'jobPriority', subfield: 'name', header: 'Priority', sort:{required: true,sortBy:'priority.name'}  },
     //{ field: 'jobAssignedRecruiter', subfield: 'users',subsubField : 'firstName',   sort:{required:false}  },

      { field: 'assignRecruiter', header: 'Recruiter', subsubField:'jobAssignedRecruiter.users.firstName', sort:{required: false} , params :{type:'Modal', labelText: "Assign Recruiter", action:'assign-recruiter', icon :'pi pi-user-edit' }},
      // { field: 'openJobCount', header: 'Open', sort:{required: false} },
      // { field: 'closedJobCount', header: 'Closed', sort:{required: false} },
      // { field: 'pendingJobCount', header: 'Pending', sort:{required: false} },
      { field: 'jobStatus', subfield: 'name', header: 'Status' , sort:{required: true,sortBy:'jobStatus.name'},params :{type:'jobStatus'}},
      // { field: '', header: 'Comments', sort:{required: false}, params: {type:'Modal', action:'job-comments',icon: 'pi pi-comments'} },
      { field: '', header: 'Comments', sort:{required: false}, params: {type:'Modal', action:'job-comments'} },
      { field: '', header: 'Actions' ,sort:{required: false}, params :{type:'Redirect',component: AssignRecruiterFormComponent,icon :'pi pi-pencil' }}

    ];
  }
  ngOnDestroy() {
    // avoid memory leaks here by cleaning up after ourselves. If we  
    // don't then we will continue to run our initialiseInvites()   
    // method on every navigationEnd event.
    if (this.subscription) {  
       this.subscription.unsubscribe();
    }
  }
  showDialog = function(bool:boolean) {
    this.display = bool;
  }
 
  
}
